/*
  wellcam-localtime — mostra data/ora delle lezioni nel FUSO DEL CLIENTE (browser),
  dove si trova in quel momento. Le superfici Liquid renderizzano un fallback in ora
  italiana (fuso negozio) dentro <span data-wc-lt="<ISO UTC>" data-wc-fmt="...">…</span>;
  qui riscriviamo il testo con new Date(ISO) formattato nel fuso locale del browser.

  data-wc-fmt:
    time      → "HH:MM"                 (ora locale)
    date      → "Dom 05 Lug"            (giorno abbr + giorno + mese)
    date-dm   → "05 Lug"               (giorno + mese)
    date-wd   → "Mar"                  (solo giorno settimana abbr)
    datetime  → "Dom 05 Lug · 07:00"

  Idempotente + esposto come window.wcLocalTime(root) per contenuti iniettati via JS.
*/
(function () {
  var WD = ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'];
  var MO = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
  function p2(n) { return String(n).padStart(2, '0'); }
  function fmt(iso, f) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return null;               // fallback server invariato
    var time = p2(d.getHours()) + ':' + p2(d.getMinutes());
    var dm = p2(d.getDate()) + ' ' + MO[d.getMonth()];
    var full = WD[d.getDay()] + ' ' + dm;
    switch (f) {
      case 'time': return time;
      case 'date-dm': return dm;
      case 'date-wd': return WD[d.getDay()];
      case 'datetime': return full + ' · ' + time;
      default: return full;                            // 'date'
    }
  }
  function apply(root) {
    (root || document).querySelectorAll('[data-wc-lt]').forEach(function (el) {
      if (el.__wcltDone) return;
      var v = fmt(el.getAttribute('data-wc-lt'), el.getAttribute('data-wc-fmt') || 'date');
      if (v != null) { el.textContent = v; el.__wcltDone = true; }
    });
  }
  window.wcLocalTime = apply;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apply(); });
  } else {
    apply();
  }
})();
